<div class="app-header" [ngClass]="{'checked': checked, 'unchecked' : !checked, 'mobile': mobile}">
    <div class="app-header-left">
        <div class="docker" (click)="showHide()">
            <label for="docker">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-panel-left docker-icon">
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M9 3v18"></path>
                </svg>
            </label>

        </div>
        <div class="marina">
            <p-dropdown [options]="marinas" optionLabel="tradeName" class="primeDropdown" [(ngModel)]="newSelectedMarina"
                (onChange)="selectMarina()" *ngIf="marinas.length > 1" appendTo="body">
            </p-dropdown>
            <div *ngIf="marinas.length <= 1" class="font-small">{{getMarinaName()}}</div>
        </div>
    </div>

    <!-- EAS-298 (CA-07..CA-09): busca global deixa o grupo da direita e vira barra
         centralizada. O centro é flex:1, então a barra nunca invade os grupos
         laterais (CA-11). -->
    <div class="app-header-center">
        <app-header-search></app-header-search>
    </div>

    <div class="app-header-right">

        <!-- EAS-298 (CA-01..CA-05): aviso de limite em LINHA ÚNICA, primeiro item da
             direita (ordem definida na spec). O texto secundário de cada estado saiu
             da barra e virou tooltip; a barra de progresso saiu junto, porque não cabe
             em linha única e não consta do formato do CA-01. As faixas, severidade e
             a fonte dos dados não foram tocadas (CA-06). -->
        <div *ngIf="showFranquiaBoats" class="franquia-badge"
            [ngClass]="{ 'franquia-badge--warning': isFranquiaWarning, 'franquia-badge--danger': !isFranquiaWarning }"
            [pTooltip]="franquiaTooltip" tooltipPosition="bottom">

            <i class="pi" [ngClass]="isFranquiaWarning ? 'pi-exclamation-triangle' : 'pi-times-circle'"></i>

            <span class="franquia-badge-main">
                <ng-container *ngIf="isFranquiaWarning">{{ qtdActiveBoats }} de {{ qtdMaxBoat }} embarcações usadas</ng-container>
                <ng-container *ngIf="isFranquiaAtLimit">Limite de {{ qtdMaxBoat }} embarcações atingido.</ng-container>
                <ng-container *ngIf="isFranquiaExceeded">{{ qtdActiveBoats }} de {{ qtdMaxBoat }} embarcações — {{ franquiaExcedentes }} excedentes.</ng-container>
            </span>

            <!-- CA-05: forma reduzida quando o aviso completo não caberia. Alternância por
                 CSS, para não depender de listener de resize. -->
            <span class="franquia-badge-short">{{ qtdActiveBoats }}/{{ qtdMaxBoat }}</span>

            <button *ngIf="!isFranquiaWarning" class="franquia-badge-support" (click)="openWhatsappSupport()"
                pTooltip="Contatar suporte" tooltipPosition="bottom">
                <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
                <span class="franquia-badge-support-label">Contatar suporte</span>
            </button>
        </div>

        <span class="user-name">
            {{ getLoggedUser() }}
        </span>
        <button
            type="button"
            class="support-button"
            (click)="openSupportPortal()"
            pTooltip="Portal de Suporte"
            tooltipPosition="bottom"
            aria-label="Abrir portal de suporte em nova aba">
            <fa-icon [icon]="['fas', 'headset']"></fa-icon>
        </button>
        <app-header-button-new-navigation></app-header-button-new-navigation>
        <app-header-button-notification></app-header-button-notification>
        <app-header-button-user-config></app-header-button-user-config>
    </div>
</div>
